module.exports = __webpack_public_path__ + "media/application/images/ui/compare-icon-close-mark2-bc99ae446079f39d31a0aee25269bdcb.svg";